var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useEffect, useState, useRef } from 'react';
import { ModalLoader } from 'root/src/client/v2/common/components/modal/ModalLoader';
import { useAuthModals } from 'root/src/client/web/auth/hooks/useAuthModals';
import { useEnterGiveawayButton } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useEnterGiveawayButton';
import { useGiveawaySection } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import toast from 'react-hot-toast';
import { useTour } from '@reactour/tour';
import { GIVEAWAY_ONBOARDING_STEPS, } from 'root/src/client/v2/giveaways/features/GiveawayAutoEnter/fixtures/giveawayOnboarding.fixture';
import { useCreatorActiveGiveaway } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
import { AutoEnteredGiveawayModal, } from 'root/src/client/v2/giveaways/features/GiveawayAutoEnter/components/AutoEnteredGiveawayModal';
import { useIsGiveawayEnter } from 'root/src/client/v2/giveaways/features/GiveawayAutoEnter/hooks/useIsGiveawayEnter';
export const useGiveawayAutoEnter = () => {
    const { isGiveawayAutoEnter } = useIsGiveawayEnter();
    const { authentication } = useAuthentication();
    const modal = useModal();
    const { displaySignInModal } = useAuthModals();
    const { onEnterGiveaway } = useEnterGiveawayButton();
    const giveaway = useCreatorActiveGiveaway();
    const { isPickingWinner } = useGiveawaySection();
    const [isLoading, setLoading] = useState(false);
    const utils = trpc.useUtils();
    const completeOnboardingMutation = trpc.giveaways.completeGiveawayOnboarding.useMutation();
    const tour = useTour();
    const isAutoEnterProcessing = useRef(false);
    const onAutoEnter = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (isLoading) {
            return;
        }
        // Lock function
        if (isAutoEnterProcessing.current) {
            return;
        }
        isAutoEnterProcessing.current = true;
        if (!authentication) {
            displaySignInModal();
            return;
        }
        try {
            setLoading(true);
            const onboardingQuery = yield utils.giveaways.showGiveawayOnboarding.fetch();
            if (onboardingQuery.shouldShowOnboarding) {
                yield completeOnboardingMutation.mutateAsync();
                modal.hide(); // Hide loading modal
                setLoading(false);
                (_a = tour.setSteps) === null || _a === void 0 ? void 0 : _a.call(tour, GIVEAWAY_ONBOARDING_STEPS);
                tour.setIsOpen(true);
                return;
            }
            if (!isPickingWinner) {
                yield onEnterGiveaway({
                    onSuccess: () => modal.show(<AutoEnteredGiveawayModal />),
                });
                setLoading(false);
                return;
            }
            toast.error('Sorry, you cannot join the Giveaway!');
        }
        catch (err) {
            console.error(err);
            setLoading(false);
            modal.hide(); // Hide loading modal
        }
    });
    useEffect(() => {
        if (isGiveawayAutoEnter && giveaway && !giveaway.isEntered) {
            void onAutoEnter();
        }
    }, [giveaway, isGiveawayAutoEnter, authentication]);
    useEffect(() => {
        if (isLoading) {
            modal.show(<ModalLoader />, { isCloseable: false });
        }
    }, [isLoading]);
    return { isLoading, onAutoEnter };
};
